import MicroModal from 'micromodal'

export const Popup = () => {
  const html = document.querySelector('html') as HTMLElement

  MicroModal.init({
    onShow: () => html.classList.add('is-popup-open'),
    onClose: () => html.classList.remove('is-popup-open'),
  })
}
